import React, { Fragment, useEffect, useState, Component } from 'react';
import Breadcrumb from '../common/breadcrumb'
import request from "../../api/api";
import { toast } from "react-toastify";
import { Search, MapPin } from 'react-feather';

class JobList_SEARCH extends Component {
    state = {
        agency_jobs: [],
        job_Role: [],
        locations_name: [],
        ag_loc: [],
        select_loc: [],
        search: '',
        search_loc: ''
    };

    componentDidMount = () => {
        this.get_agency_loc();
        this.get_agency_added_jobs();
        this.selected_job_type();
    };

    get_agency_loc = (search = '') => {
        let { select_loc, locations_name } = this.state;
        if (select_loc && select_loc.length > 0) {
            select_loc.map(item => {
                document.getElementById(String(item)).checked = false;
            });
            this.setState({ locations_name: [], select_loc: [] });
        }
        request({
            url: '/candidate/get/agency/locationss',
            method: 'POST',
            data: { search }
        }).then((res) => {
            if (res && +res.status === 1) {
                this.setState({ ag_loc: [...res.response] });
                this.checkandchecked();
            }
        }).catch((err) => {
            console.log(`err in /candidate/get/agency/locationss ${err}`)
        })
    };

    get_agency_added_jobs = (search = '') => {
        request({
            url: '/candidate/get/agency/jobs',
            method: 'POST',
            data: { search }
        }).then((res) => {
            if (res && +res.status === 1) {
                this.setState({ agency_jobs: [...res.response] });
            }
        }).catch((err) => {
            console.log(`err in /candidate/get/agency/jobs ${err}`)
        })
    };

    selected_job_type = () => {
        request({
            url: '/candidate/get/selected/job_type',
            method: 'POST',
            data: {}
        }).then((res) => {
            if (res && +res.status === 1) {
                this.setState({
                    job_Role: res.response && res.response.job_type && res.response.job_type.length > 0 ? [...res.response.job_type].map(e => String(e)) : [],
                    select_loc: res.response && res.response.locations && res.response.locations.length > 0 ? res.response.locations : [],
                    locations_name: res.response && res.response.locations_name && res.response.locations_name.length > 0 ? res.response.locations_name : []
                });
                this.checkandchecked();
            }
        }).catch((err) => {
            console.log(`err in /candidate/get/selected/job_type ${err}`)
        })
    };

    checkandchecked = () => {
        let { ag_loc, select_loc } = this.state;
        if (select_loc && select_loc.length > 0 && ag_loc && ag_loc.length > 0) {
            select_loc.map(item => {
                document.getElementById(String(item)).checked = true;
            });
        }
    }

    link_hover = evt => {
        evt.preventDefault();
        evt.stopPropagation();
    };

    applyJob = (evt, data) => {
        evt.preventDefault();
        evt.stopPropagation();
        request({
            url: '/candidate/updated/job_type',
            method: 'POST',
            data: {
                job_type: data.job_type,
                job_type_name: data.job_type_name
            }
        }).then((res) => {
            if (res && +res.status === 1) {
                toast.success(res.response);
                setTimeout(() => {
                    this.get_agency_added_jobs();
                    this.selected_job_type();
                }, 1500);
            } else {
                toast.error(res.response);
            }
        }).catch((err) => {
            console.log(`err in/candidate/updated/job_type ${err}`)
        })
    };

    changesearch = (e) => {
        this.setState({ search_loc: e.target.value });
        this.get_agency_loc(e.target.value);
    };

    change_search = (e) => {
        this.setState({ search: e.target.value });
        this.get_agency_added_jobs(e.target.value);
    };

    save_loc = evt => {
        let { select_loc, locations_name } = this.state;
        evt.preventDefault();
        evt.stopPropagation();
        if (select_loc && select_loc.length === 0) {
            return toast.info('Location is required');
        }
        if (locations_name && locations_name.length === 0) {
            return toast.info('Location is required');
        }
        request({
            url: '/candidate/updated/locations',
            method: 'POST',
            data: {
                locations: select_loc,
                locations_name
            }
        }).then((res) => {
            if (res && +res.status === 1) {
                toast.success(res.response);
                setTimeout(() => {
                    this.get_agency_added_jobs();
                    this.selected_job_type();
                    this.get_agency_loc();
                }, 1000);
            } else {
                toast.error(res.response);
            }
        }).catch((err) => {
            console.log(`err in /candidate/updated/locations ${err}`)
        })
    };

    check_id = (evt, id, name) => {
        let checked = evt.target.checked;
        let { select_loc, locations_name } = this.state;
        if (checked) {
            document.getElementById(id).checked = true;
            select_loc.push(String(id));
            locations_name.push(String(name));
            this.setState({ select_loc, locations_name });
        } else {
            document.getElementById(id).checked = false;
            select_loc = select_loc.filter((item) => {
                if (String(item) !== String(id)) {
                    return item;
                }
            });
            locations_name = locations_name.filter((item) => {
                if (String(item) !== String(name)) {
                    return item;
                }
            });
            this.setState({ select_loc, locations_name });
        }
    };

    render() {
        let { agency_jobs, job_Role, locations_name, ag_loc, select_loc, search, search_loc } = this.state;
        return (
            <Fragment>
                <Breadcrumb title="List View" parent="Job Search" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-3 xl-40">
                            <div className="default-according style-1 faq-accordion job-accordion" id="accordionoc">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="card">
                                            <div className="card-body filter-cards-view animate-chk">
                                                <div className="job-filter">
                                                    <div className="faq-form">
                                                        <input className="form-control" name="search" type="text" placeholder="Search.." value={search} onChange={(e) => { this.change_search(e) }} />
                                                        <Search className="search-icon" />
                                                    </div>
                                                </div>
                                                <div className="job-filter">
                                                    <div className="faq-form">
                                                        <input className="form-control" name="search_loc" type="text" placeholder="Search location.." value={search_loc} onChange={(e) => { this.changesearch(e) }} />
                                                        <MapPin className="search-icon" />
                                                    </div>
                                                </div>
                                                <div className="checkbox-animated">
                                                    {
                                                        ag_loc && ag_loc.length > 0 ?
                                                            ag_loc.map((item) => {
                                                                return (
                                                                    <>
                                                                        <label className="d-block" htmlFor="chk-ani" key={item._id}>
                                                                            <input className="checkbox_animated" id={String(item._id)} type="checkbox" onClick={(e) => { this.check_id(e, item._id, item.name) }} /> {item.name} </label>
                                                                    </>
                                                                )
                                                            })
                                                            : <label className="d-block" htmlFor="chk-ani5">No locations found  </label>
                                                    }
                                                </div>
                                                <button className="btn btn-primary text-center" disabled={ag_loc.length === 0 ? true : false} onClick={(e) => { this.save_loc(e) }} type="button">Apply Location</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-9 xl-60" >
                            {agency_jobs.map((data, i) => {
                                return (
                                    <div className={`card ribbon-vertical-left-wrapper`} key={i}>
                                        <div className="job-search">
                                            <div className="card-body">
                                                <div className="media">
                                                    <img className="img-40 img-fluid m-r-20" src={data.logo} alt="" />
                                                    <div className="media-body">
                                                        <h6 className="f-w-600"><a href="" onClick={(e) => { this.link_hover(e) }}>{data.job_type_name}</a>
                                                            {(!job_Role.includes(String(data.job_type)) ? <button className="btn btn-primary pull-right" style={{ cursor: 'pointer' }} type='button' onClick={(e) => { this.applyJob(e, data) }}> Apply for the job </button>
                                                                : <button className="btn btn-success pull-right" > Applied </button>
                                                            )}
                                                        </h6>
                                                        <p>{data.roles_responsibilities}
                                                            <span>
                                                                <i className="fa fa-star font-warning"></i>
                                                                <i className="fa fa-star font-warning"></i>
                                                                <i className="fa fa-star font-warning"></i>
                                                                <i className="fa fa-star font-warning"></i>
                                                                <i className="fa fa-star font-warning"></i>
                                                            </span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <p>
                                                    {data.description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
};
export default JobList_SEARCH;